module.exports = __webpack_public_path__ + "img/illustration-your-users.8a5af995.svg";